import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white shadow-lg mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col items-center justify-center text-gray-600 text-sm">
          <p>© WEURO 2025 She Embrace Cup.</p>
          <p className="mt-2">Made by <a href='https://www.linkedin.com/in/shuyaochen/' className='text-blue-500 hover:text-accent'>Shuyao Chen</a> with ❤️ for women's football</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 